<template>
  <div>
    <FormulateForm
      ref="form"
      name="formStore"
    >
      <b-card-actions
        ref="main-card"
        no-actions
        :show-loading="loading || busy"
        :title="$t('Dados Cadastrais')"
      >
        <b-row>
          <b-col md="3">
            <e-company-combo
              id="company-id"
              v-model="store.companyId"
              name="company-id"
              :required="true"
              :label="$t('Empresa')"
              @input="loadCompanyData(store.companyId)"
            />
          </b-col>
          <b-col md="1">
            <FormulateInput
              id="store-id"
              v-model="store.id"
              name="id"
              class="required"
              :label="$t('Id')"
              :type="isEdition ? 'label' : 'number'"
              validation="required"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="identification"
              v-model="store.identification"
              name="identification"
              class="required"
              :label="$t('Identificação')"
              placeholder="M01, F01, Q01, etc."
              type="text"
              validation="required"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="company-name"
              v-model="store.companyName"
              name="companyName"
              :label="$t('Razão Social')"
              type="label"
              :instruction="$t('Herdado da empresa selecionada')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="trading-name"
              v-model="store.tradingName"
              name="tradingName"
              type="text"
              class="required"
              :label="$t('Nome Fantasia')"
              validation="required"
            />
          </b-col>
          <b-col
            v-show="false"
            md="3"
          >
            <e-store-combo
              id="order-store_id"
              v-model="store.headquartersStoreId"
              name="headquartersStoreId"
              :required="false"
              :label="$t('Matriz')"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="type"
              v-model="store.type"
              name="type"
              :type="isEdition && store.type === 'Kiosk' ? 'label' : 'vue-select'"
              class="required"
              validation="required"
              :label="$t('Tipo')"
              :options="storeTypes()"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="region"
              v-model="store.region"
              name="region"
              type="label"
              :label="$t('Região')"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="businessModel"
              v-model="store.businessModel"
              name="businessModel"
              type="vue-select"
              class="required"
              validation="required"
              :label="$t('Modelo')"
              :options="storeBusinessModels()"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="headId"
              v-model="store.headId"
              name="headId"
              type="vue-select"
              class="required"
              validation="required"
              :label="$t('Head')"
              :options="headOptions"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="directorId"
              v-model="store.directorId"
              name="directorId"
              type="vue-select"
              :label="$t('Diretor')"
              :options="directorOptions"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="directorCommercialId"
              v-model="store.directorCommercialId"
              name="directorCommercialId"
              type="vue-select"
              :label="$t('Diretor Comercial')"
              :options="directorCommercialOptions"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="invoice-serie-number"
              v-model="store.invoiceSerialNumber"
              name="invoiceSerialNumber"
              type="number"
              class="required"
              :label="$t('Série da NFe')"
              :instruction="$t('Série utilizado para emissão da NF-e')"
              validation="required"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="cnpj"
              v-model="store.cnpj"
              name="cnpj"
              filter="cpfCnpj"
              :label="$t('CNPJ')"
              type="label"
              :instruction="$t('Herdado da empresa selecionada')"
            />
          </b-col>
          <b-col md="2">
            <FormulateInput
              id="state-registration"
              v-model="store.stateRegistration"
              name="stateRegistration"
              class="required"
              maxlength="20"
              :label="$t('Inscrição Estadual')"
              type="label"
              :instruction="$t('Herdado da empresa selecionada')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="state-registration-of-tax-substitute"
              v-model="store.stateRegistrationOfTaxSubstitute"
              name="stateRegistrationOfTaxSubstitute"
              maxlength="20"
              :label="$t('I.E. do Substituto Tributário')"
              type="label"
              :instruction="$t('Herdado da empresa selecionada')"
            />
          </b-col>
          <b-col md="3">
            <FormulateInput
              id="municipal-inscription"
              v-model="store.municipalInscription"
              name="municipalInscription"
              maxlength="20"
              :label="$t('Inscrição Municipal')"
              type="label"
              :instruction="$t('Herdado da empresa selecionada')"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="investors"
              v-model="store.investors"
              name="investors"
              type="vue-select"
              multiple
              :label="$t('Investidores')"
              :options="investorsOptions"
              :placeholder="$t('Selecione')"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="email"
              v-model="store.email"
              name="email"
              type="text"
              class="required"
              :label="$t('E-mail')"
              validation="required"
            />
          </b-col>
          <b-col md="1">
            <p class="h6">
              Ativo?
            </p>
            <e-status-badge
              :status="!!store.active"
              type="yesNo"
            />
          </b-col>
        </b-row>
      </b-card-actions>

      <b-tabs class="mt-1">
        <b-tab
          :title="$t('Endereço')"
          active
        >
          <e-address
            ref="address"
            v-model="store.address"
            :required="false"
            :show-map="true"
            :show-lat-lng="true"
            :required-lat-lng="true"
            :show-loading="loading || busy"
          />
        </b-tab>

        <b-tab :title="$t('Telefones')">
          <b-card-actions
            ref="main-card"
            no-actions
            :show-loading="loading || busy"
            :title="$t('Telefones')"
          >
            <FormulateInput
              v-slot="{ index }"
              ref="telephoneGroup"
              v-model="store.telephones"
              name="telephones"
              type="group"
              error-behavior="live"
              :repeatable="true"
              :add-label="$t('Adicionar Telefone')"
            >
              <b-row>
                <b-col md="5">
                  <FormulateInput
                    :id="`store-telephone-type-${index}`"
                    type="vue-select"
                    :name="`type`"
                    class="required"
                    :label="$t('Tipo')"
                    :options="telephoneTypes()"
                  />
                </b-col>
                <b-col md="7">
                  <FormulateInput
                    :id="`store-telephone-number-${index}`"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    type="text"
                    :name="`number`"
                    class="required"
                    validation="optional|min:14"
                    maxlength="15"
                    :instruction="$t('Exemplo: (99) 99999-9999')"
                    :label="$t('Telefone')"
                  />
                </b-col>
              </b-row>
            </FormulateInput>
          </b-card-actions>
        </b-tab>

        <b-tab :title="$t('Delivery')">
          <b-card-actions
            no-actions
            :show-loading="loading || busy"
            :title="$t('Delivery')"
          >
            <b-row>
              <b-col md="2">
                <FormulateInput
                  id="store-delivery"
                  v-model="store.delivery"
                  name="delivery"
                  type="switch"
                  :label="$t('Oferece Delivery?')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="email-delivery"
                  v-model="store.emailDelivery"
                  name="emailDelivery"
                  type="text"
                  :class="store.delivery ? 'required' : ''"
                  :label="$t('E-mail Delivery')"
                  :instruction="$t('E-mail usado para o processo de entregas')"
                  :validation="store.delivery ? 'required' : ''"
                />
              </b-col>

              <b-col md="2">
                <FormulateInput
                  id="max-schedule"
                  v-model="store.maxScheduleDays"
                  name="maxScheduleDays"
                  type="text-number"
                  :class="store.delivery ? 'required' : ''"
                  :label="$t('Qtd. dias p/ entrega')"
                  :instruction="$t('Quantidade máxima de dias para entrega de pedidos.')"
                  :validation="store.delivery ? 'required' : ''"
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="min-delivery-schedule-minutes"
                  v-model.number="store.minDeliveryScheduleMinutes"
                  name="minDeliveryScheduleMinutes"
                  type="number"
                  class="required"
                  min="1"
                  max="1440"
                  step="1"
                  validation="required|number|min:1|max:1440"
                  :validation-messages="{
                    required: $t(
                      'STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'
                    ),
                    number: $t(
                      'STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'
                    ),
                    min: $t(
                      'STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'
                    ),
                    max: $t(
                      'STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'
                    ),
                  }"
                  :label="$t('Tempo mínimo de entrega')"
                  :instruction="
                    $t(
                      'Tempo, em minutos, entre o pedido e a entrega. Valida o agendamento e define a janela do acionamento automático.'
                    )
                  "
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="auto-delivery-enabled"
                  v-model="store.autoDeliveryEnabled"
                  name="autoDeliveryEnabled"
                  type="switch"
                  :label="$t('Delivery automático')"
                  :instruction="
                    $t(
                      'Quando habilitado, os pedidos online da loja são despachados automaticamente aos fornecedores de entrega.'
                    )
                  "
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="lending-schedule-enabled"
                  v-model="store.lendingScheduleEnabled"
                  name="lendingScheduleEnabled"
                  type="switch"
                  :label="$t('Agendamento de chope/comodato')"
                  :instruction="
                    $t(
                      'Quando habilitado, pedidos de comodato com entrega escolhem o horário pela agenda de instalação (tempo de instalação da loja).'
                    )
                  "
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="lending-installation-minutes"
                  v-model.number="store.lendingInstallationMinutes"
                  name="lendingInstallationMinutes"
                  type="number"
                  class="required"
                  min="15"
                  max="480"
                  step="5"
                  validation="required|number|min:15|max:480|multipleOf5"
                  :validation-messages="{
                    required: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
                    number: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
                    min: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
                    max: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
                    multipleOf5: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
                  }"
                  :validation-rules="{ multipleOf5 }"
                  :label="$t('Tempo de instalação do comodato')"
                  :instruction="
                    $t(
                      'Tempo, em minutos, de uma entrega de chope/comodato. Define o tamanho dos horários da agenda de instalação.'
                    )
                  "
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="motoboy-enabled"
                  v-model="store.motoboyEnabled"
                  name="motoboyEnabled"
                  type="switch"
                  :label="$t('Utiliza Motoboys')"
                  :instruction="
                    $t(
                      'Quando desabilitado, o painel de delivery não exibe a seção de Motoboys nem permite designar Motoboy aos pedidos da loja.'
                    )
                  "
                />
              </b-col>

              <b-col md="3">
                <FormulateInput
                  id="motoboy-assignment-time-limit-minutes"
                  v-model.number="store.motoboyAssignmentTimeLimitMinutes"
                  name="motoboyAssignmentTimeLimitMinutes"
                  type="number"
                  class="required"
                  min="1"
                  max="120"
                  step="1"
                  validation="required|number|min:1|max:120"
                  :validation-messages="{
                    required: $t(
                      'STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE'
                    ),
                    number: $t(
                      'STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE'
                    ),
                    min: $t(
                      'STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE'
                    ),
                    max: $t(
                      'STORE.VALIDATION_ERROR.MOTOBOY_ASSIGNMENT_TIME_LIMIT_OUT_OF_RANGE'
                    ),
                  }"
                  :label="$t('Tempo limite para atribuir Motoboy')"
                  :instruction="
                    $t('Tempo, em minutos, para atribuir um Motoboy antes do acionamento automático.')
                  "
                />
              </b-col>
              <b-col md="2">
                <FormulateInput
                  id="deliveryType"
                  v-model="store.deliveryType"
                  name="deliveryType"
                  type="vue-select"
                  :instructions="[
                    { text: $t('Tipo de entregas que a loja realiza') },
                    { text: $t('Cidade: realiza entregas na cidade inteira.') },
                    {
                      text: $t(
                        'Polígono: realiza entregas dentro de uma determinada área da cidade.'
                      ),
                    },
                  ]"
                  :label="$t('Tipo do Delivery')"
                  :options="storeDeliveryTypes()"
                  :placeholder="$t('Selecione')"
                />
              </b-col>

              <b-col md="2">
                <FormulateInput
                  id="store-delivery-others-cities"
                  v-model="store.deliveryOthersCities"
                  name="deliveryOthersCities"
                  type="switch"
                  :instruction="
                    $t('Permite adicionar outras cidades que a loja poderá realizar entrega.')
                  "
                  :label="$t('Entrega em outras cidades?')"
                />
              </b-col>

              <b-col md="2">
                <FormulateInput
                  id="store-delivery-send-lat-lng"
                  v-model="store.sendLatLngToDeliverySuppliers"
                  name="sendLatLngToDeliverySuppliers"
                  type="switch"
                  :instruction="
                    $t(
                      'Quando selecionado, o sistema envia Lat/Lng para realizar os pedidos aos fornecedores de entrega terceirizados.'
                    )
                  "
                  :label="$t('Enviar Lat/Lng?')"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <hr>
                <h6 class="mb-1">
                  {{ $t('Fornecedores de Delivery') }}
                </h6>
                <p class="text-muted">
                  {{
                    $t(
                      'Fornecedores terceirizados que podem realizar as entregas desta loja. O fornecedor padrão é o utilizado no acionamento automático.'
                    )
                  }}
                </p>
              </b-col>

              <b-col md="5">
                <FormulateInput
                  id="store-delivery-supplier-to-add"
                  v-model="deliverySupplierToAdd"
                  type="vue-select"
                  :label="$t('Fornecedor')"
                  :placeholder="$t('Selecione')"
                  :options="availableDeliverySupplierOptions"
                />
              </b-col>
              <b-col
                md="3"
                class="d-flex align-items-center"
              >
                <e-button
                  variant="primary"
                  :text="$t('Adicionar Fornecedor')"
                  @click="onAddDeliverySupplier"
                />
              </b-col>

              <b-col md="12">
                <b-table
                  id="store-delivery-suppliers-table"
                  class="bordered"
                  responsive
                  striped
                  show-empty
                  :empty-text="getEmptyTableAddMessage($t('Fornecedor de delivery'), 'male')"
                  :items="getStoreDeliverySuppliers"
                  :fields="deliverySupplierFields"
                >
                  <template #cell(actions)="row">
                    <e-grid-actions
                      :show-update="false"
                      :show-delete="true"
                      @delete="onRemoveDeliverySupplier(row.item)"
                    />
                  </template>

                  <template #cell(supplier)="row">
                    {{ deliverySupplierLabel[row.item.supplier] || row.item.supplier }}
                  </template>

                  <template #cell(isDefault)="row">
                    <FormulateInput
                      :id="`store-delivery-supplier-default-${row.index}`"
                      :value="row.item.isDefault"
                      type="switch"
                      :name="`isDefault-${row.index}`"
                      label=""
                      @input="onSetDefaultDeliverySupplier(row.item, $event)"
                    />
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row v-if="store.deliveryOthersCities">
              <b-col
                md="12"
                class="d-flex justify-content-end mb-1"
              >
                <e-button
                  variant="primary"
                  :text="$t('Adicionar Cidade')"
                  @click="onShowDeliveryLocationSidebar()"
                />
              </b-col>

              <b-col md="12">
                <b-table
                  id="stores-other-cities-table"
                  class="bordered"
                  responsive
                  striped
                  show-empty
                  :empty-text="getEmptyTableAddMessage($tc('ADDRESS.CITY_NAME'), 'female')"
                  :items="getStoreDeliveryLocations"
                  :fields="deliveryLocationFields"
                >
                  <template #cell(actions)="row">
                    <e-grid-actions
                      :show-update="false"
                      :show-delete="true"
                      @delete="onRemoveDeliveryLocation(row.item)"
                    />
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row v-if="store.deliveryType === storeDeliveryTypesEnum.POLYGON">
              <b-col
                md="12"
                class="mb-1"
              >
                <p class="mb-1">
                  {{
                    $t(
                      'Defina o polígono de entrega da loja importando uma planilha (.csv) no formato WKT (item POLYGON) ou desenhando diretamente no mapa. Arraste os pontos para ajustar.'
                    )
                  }}
                </p>
                <div class="d-flex align-items-center flex-wrap">
                  <e-button
                    variant="primary"
                    :text="$t('Importar planilha de polígono')"
                    @click="importPolygonSpreadsheet"
                  />
                  <e-button
                    class="ml-1"
                    :variant="isDrawingPolygon ? 'warning' : 'primary'"
                    :text="isDrawingPolygon ? $t('Concluir desenho') : $t('Desenhar polígono')"
                    @click="toggleDrawPolygon"
                  />
                  <e-button
                    v-if="polygonPaths.length"
                    class="ml-1"
                    variant="danger"
                    :text="$t('Remover polígono')"
                    @click="clearPolygon"
                  />
                  <span
                    v-if="polygonPaths.length"
                    class="ml-1"
                  >
                    {{ polygonPaths.length }} {{ $t('pontos carregados') }}
                  </span>
                </div>
                <small
                  v-if="isDrawingPolygon"
                  class="text-primary d-block mt-1"
                >
                  {{
                    $t(
                      'Clique no mapa para adicionar os pontos e clique em "Concluir desenho" ao finalizar.'
                    )
                  }}
                </small>
              </b-col>
              <b-col md="12">
                <GmapMap
                  ref="polygonMapRef"
                  :center="polygonMapCenter"
                  :zoom="11"
                  map-type-id="roadmap"
                  style="width: 100%; height: 500px"
                />
              </b-col>
            </b-row>
          </b-card-actions>
        </b-tab>

        <b-tab :title="$t('Loja Virtual')">
          <b-card-actions
            ref="main-card"
            no-actions
            :show-loading="loading || busy"
            :title="$t('Loja Virtual')"
          >
            <b-row>
              <b-col md="2">
                <FormulateInput
                  id="active-online"
                  v-model="store.activeOnline"
                  name="activeOnline"
                  type="switch"
                  :label="$t('Venda no Site')"
                  :instruction="
                    $t('Quando habilitado, a loja estará disponível para venda no site e no app')
                  "
                />
              </b-col>
            </b-row>
            <b-card
              :title="$t('App B2C')"
              class="bg-light-gray"
            >
              <b-row>
                <b-col md="3">
                  <FormulateInput
                    id="max-product-items-sell"
                    v-model="store.maxProductItemsSell"
                    name="maxProductItemsSell"
                    type="number"
                    :label="$t('Qtd. Máxima de itens')"
                    :instruction="
                      $t(
                        'Indica quantos itens do mesmo produto a loja pode vender nos canais digitais B2C'
                      )
                    "
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="max-order-value"
                    v-model="store.maxOrderValue"
                    name="maxOrderValue"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Valor máx. de venda')"
                    :instruction="$t('Valor máximo permitido para uma venda')"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-pix"
                    v-model="store.onlinePaymentConfig.pix"
                    name="onlinePaymentPix"
                    type="switch"
                    :label="$t('Pagto Pix (online)')"
                    :instruction="
                      $t('Quando habilitado, a loja aceitará pagamento via pix no site e no app')
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-credit"
                    v-model="store.onlinePaymentConfig.credit"
                    name="onlinePaymentCredit"
                    type="switch"
                    :label="$t('Pagto Crédito (online)')"
                    :instruction="
                      $t(
                        'Quando habilitado, a loja aceitará pagamento via cartão de crédito no site e no app'
                      )
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-wallet"
                    v-model="store.onlinePaymentConfig.wallet"
                    name="onlinePaymentWallet"
                    type="switch"
                    :label="$t('Pagto Wallet (online)')"
                    :instruction="
                      $t('Quando habilitado, a loja aceitará pagamento via wallet no site e no app')
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-cash"
                    v-model="store.onlinePaymentConfig.cash"
                    name="onlinePaymentCash"
                    type="switch"
                    :label="$t('Pagto Dinheiro (na entrega)')"
                    :instruction="
                      $t(
                        'Quando habilitado, a loja aceitará pagamentos em dinheiro na entrega de pedidos feitos no site e app'
                      )
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-pickup"
                    v-model="store.onlinePaymentConfig.payOnPickup"
                    name="onlinePaymentPayOnPickup"
                    type="switch"
                    :label="$t('Pagto Cartão (na entrega)')"
                    :instruction="
                      $t(
                        'Quando habilitado, a loja aceitará pagamentos em cartão de crédito/débito na entrega de pedidos feitos no site e app'
                      )
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-chat-enabled"
                    v-model="store.onlineChatEnabled"
                    name="onlineChatEnabled"
                    type="switch"
                    :label="$t('Chat ativo')"
                    :instruction="
                      $t(
                        'Quando habilitado, a loja poderá ser acionada pelos clientes via chat no app'
                      )
                    "
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-pix-limit"
                    v-model="store.onlinePaymentConfig.pixLimit"
                    name="onlinePaymentPixLimit"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Limite Pix')"
                    :instruction="$t('Limite de valor para pagamento no PIX no site e no app')"
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-credit-limit"
                    v-model="store.onlinePaymentConfig.creditLimit"
                    name="onlinePaymentCreditLimit"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Limite Crédito')"
                    :instruction="
                      $t('Limite de valor para pagamento com cartão de crédito no site e no app')
                    "
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-payment-wallet-limit"
                    v-model="store.onlinePaymentConfig.walletLimit"
                    name="onlinePaymentWalletLimit"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Limite Wallet')"
                    :instruction="$t('Limite de valor para pagamento com wallet no site e no app')"
                  />
                </b-col>
                <b-col
                  v-if="false"
                  md="2"
                >
                  <FormulateInput
                    id="online-payment-cash-limit"
                    v-model="store.onlinePaymentConfig.cashLimit"
                    name="onlinePaymentCashLimit"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Limite Dinheiro')"
                    :instruction="$t('Limite de valor para pagamento em dinheiro no site e no app')"
                  />
                </b-col>
                <b-col md="2">
                  <FormulateInput
                    id="online-liveness-enabled"
                    v-model="store.livenessEnabled"
                    name="livenessEnabled"
                    type="switch"
                    :label="$t('Facial ativa')"
                    :instruction="
                      $t(
                        'Quando habilitado, a loja poderá utilizar reconhecimento facial para autenticação de clientes no app'
                      )
                    "
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-credit-acquirer"
                    v-model="store.onlinePaymentConfig.creditAcquirer"
                    name="onlinePaymentCreditAcquirer"
                    type="vue-select"
                    :label="$t('Fornecedor do cartão (online)')"
                    :placeholder="$t('Padrão (parâmetro global)')"
                    :options="onlinePaymentAcquirerOptions()"
                    :instruction="
                      $t(
                        'Quem processa o cartão de crédito no app. Vazio usa o parâmetro global; sem os dois, o cartão não é oferecido'
                      )
                    "
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-credit-installment"
                    v-model="store.onlinePaymentConfig.creditInstallment"
                    name="onlinePaymentCreditInstallment"
                    type="switch"
                    :label="$t('Crédito parcelado (online)')"
                    :instructions="[
                      {
                        text: $t(
                          'Quando habilitado, o app oferece crédito parcelado pelo estabelecimento (sem juros), somente com cartão pela Getnet.'
                        ),
                      },
                      {
                        text: $t(
                          'Também exige o pagamento parcelado habilitado na loja, uma política de parcelamento vigente e o parâmetro global ligado.'
                        ),
                      },
                    ]"
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-credit-saved-cards"
                    v-model="store.onlinePaymentConfig.creditSavedCards"
                    name="onlinePaymentCreditSavedCards"
                    type="switch"
                    :label="$t('Cartão salvo (online)')"
                    :instruction="
                      $t(
                        'Quando habilitado, o cliente pode salvar o cartão e pagar com ele no app. Somente com cartão pela Getnet e com o parâmetro global ligado'
                      )
                    "
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-credit-three-ds-required"
                    v-model="creditThreeDsRequiredOption"
                    name="onlinePaymentCreditThreeDsRequired"
                    type="vue-select"
                    :disabled="store.onlinePaymentConfig.creditAcquirer === 'STRIPE'"
                    :label="$t('Exigir 3DS (online)')"
                    :placeholder="$t('Padrão (parâmetro global)')"
                    :options="threeDsRequiredOptions"
                    :instruction="
                      $t(
                        'Exige a autenticação do banco (3DS) no cartão pela Getnet. Vazio segue o parâmetro global; o valor da loja prevalece. Indisponível com Stripe'
                      )
                    "
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-pix-biometric"
                    v-model="store.onlinePaymentConfig.pixBiometric"
                    name="onlinePaymentPixBiometric"
                    type="switch"
                    :label="$t('Pix biometria (online)')"
                    :instruction="
                      $t(
                        'Quando habilitado, o app oferece o Pix por aproximação (biometria no app do banco) pela Getnet. Também exige o parâmetro global ligado'
                      )
                    "
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-pix-biometric-limit"
                    v-model="store.onlinePaymentConfig.pixBiometricLimit"
                    name="onlinePaymentPixBiometricLimit"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    :label="$t('Limite Pix biometria')"
                    :instruction="
                      $t('Limite de valor para o Pix biometria no app. Vazio usa o limite do Pix')
                    "
                  />
                </b-col>
                <b-col md="3">
                  <FormulateInput
                    id="online-payment-wallet-acquirer"
                    v-model="store.onlinePaymentConfig.walletAcquirer"
                    name="onlinePaymentWalletAcquirer"
                    type="vue-select"
                    :label="$t('Fornecedor da wallet (online)')"
                    :placeholder="$t('Stripe')"
                    :options="onlinePaymentAcquirerOptions()"
                    :instruction="
                      $t('Quem processa o Google Pay e o Apple Pay no app. Vazio é Stripe')
                    "
                  />
                </b-col>
                <b-col
                  v-if="store.onlinePaymentConfig.walletAcquirer === 'GETNET'"
                  md="3"
                >
                  <FormulateInput
                    id="online-payment-google-pay-gateway-merchant-id"
                    v-model="store.onlinePaymentConfig.googlePayGatewayMerchantId"
                    name="onlinePaymentGooglePayGatewayMerchantId"
                    type="text"
                    maxlength="100"
                    :class="{ required: store.onlinePaymentConfig.wallet }"
                    :validation="store.onlinePaymentConfig.wallet ? 'required' : ''"
                    :label="$t('Google Pay gatewayMerchantId')"
                    :instruction="
                      $t(
                        'Identificador fornecido pela Getnet para o Google Pay. Obrigatório com a wallet pela Getnet'
                      )
                    "
                  />
                </b-col>
              </b-row>
            </b-card>
            <b-row>
              <b-col md="6">
                <FormulateInput
                  v-model="imageWideLocal"
                  name="imageWideLocal"
                  type="uploader"
                  deletable="true"
                  max-files="1"
                  :meta="false"
                  :label="$t('Imagem Wide')"
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  v-model="imageSquareLocal"
                  name="imageSquareLocal"
                  type="uploader"
                  deletable="true"
                  max-files="1"
                  :meta="false"
                  :label="$t('Imagem Quadrada')"
                />
              </b-col>
            </b-row>
          </b-card-actions>
        </b-tab>

        <b-tab
          v-if="store.type === 'Bar'"
          :title="$t('Bar')"
        >
          <b-card-actions
            v-if="store.type === 'Bar'"
            no-actions
            :show-loading="loading || busy"
            :title="$t('Bar')"
          >
            <b-row md="5">
              <b-col md="12">
                <FormulateInput
                  id="waiter-comission"
                  v-model="store.waiterComission"
                  name="waiterComission"
                  type="switch"
                  :label="$t('Habilitar gorjeta do garçom')"
                  :instruction="
                    $t(
                      'Quando habilitado, a loja do tipo Bar irá habilitar opção da gorjeta pro garçom'
                    )
                  "
                />
              </b-col>
            </b-row>

            <b-row v-show="store.waiterComission">
              <b-col md="5">
                <b-col
                  md="12"
                  class="d-flex justify-content-end mb-1"
                >
                  <e-button
                    variant="primary"
                    :text="$t('Adicionar gorjeta')"
                    @click="onAddWaiterComission"
                  />
                </b-col>

                <b-col md="12">
                  <b-table
                    id="stores-waiter-comission-table"
                    class="bordered"
                    responsive
                    striped
                    show-empty
                    :items="getStoreWaiterComissions"
                    :fields="waiterComissionFields"
                  >
                    <!-- :empty-text="getEmptyTableAddMessage($tc('ADDRESS.CITY_NAME'), 'female')" -->
                    <template #cell(actions)="row">
                      <e-grid-actions
                        :show-update="false"
                        :show-delete="true"
                        @delete="onRemoveWaiterComission(row.item)"
                      />
                    </template>

                    <template #cell(comissionFee)="row">
                      <FormulateInput
                        :id="`waiter_comission_fee-${row.index}`"
                        v-model="row.item.comissionFee"
                        type="text-percetage"
                        validation="number|min:0.01"
                        name="comissionFee"
                        currency="%"
                        :precision="2"
                        label=""
                        currency-symbol-position="suffix"
                      />
                    </template>
                  </b-table>
                </b-col>
              </b-col>
            </b-row>
          </b-card-actions>
        </b-tab>

        <b-tab :title="$t('Parametrizações')">
          <b-card-actions
            no-actions
            :show-loading="loading || busy"
            :title="$t('Parametrizações')"
          >
            <b-row>
              <b-col md="3">
                <FormulateInput
                  id="max_cash_amount_pay_box"
                  v-model="store.maxCashAmountPayBox"
                  name="maxCashAmountPayBox"
                  :label="$t('Valor máx. permitido no PDV')"
                  type="text-number"
                  currency="R$"
                  :precision="2"
                  :instructions="[
                    {
                      text: $t(
                        'Valor máximo em dinheiro permitido na gaveta dos PDVs desta loja, caso o valor seja excedido a tela do caixa será bloqueado e pedirá para realizar uma sangria.'
                      ),
                    },
                    {
                      text: $t(
                        'Caso não seja informado, o valor de R$ 900 será aplicado como limite padrão.'
                      ),
                    },
                  ]"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="max_accounts_payable_value_on_pay_box"
                  v-model="store.maxAccountsPayableValueOnPayBox"
                  name="maxAccountsPayableValueOnPayBox"
                  :label="$t('Valor máx. permitido no mês para despesa no PDV')"
                  type="text-number"
                  currency="R$"
                  :precision="2"
                  :instructions="[
                    {
                      text: $t('Valor máximo permitido do PDV para criar despesa no mês.'),
                    },
                    {
                      text: $t(
                        'Caso não seja informado, não haverá limite para criação de despesas no caixa.'
                      ),
                    },
                  ]"
                />
              </b-col>
              <b-col>
                <FormulateInput
                  v-model="store.lockPdvOpening"
                  :instruction="
                    $t(
                      'Quando habilitado, impedirá a abertura do caixa se o valor digitado for maior que o saldo disponível na conta troco.'
                    )
                  "
                  type="switch"
                  :label="$t('Trava na abertura de caixa')"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <FormulateInput
                  id="purchase_requisition_enabled"
                  v-model="store.purchaseRequisitionEnabled"
                  name="purchaseRequisitionEnabled"
                  type="switch"
                  :label="$t('Requisição de compra habilitada')"
                  :instruction="
                    $t(
                      'Quando desabilitado, os pedidos de compra desta loja não abrirão fluxo de aprovação por falta de requisição de compra.'
                    )
                  "
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  id="purchase_requisition_generation_days"
                  v-model="store.purchaseRequisitionGenerationDays"
                  name="purchaseRequisitionGenerationDays"
                  type="vue-select"
                  :label="$t('Dias de geração das requisições de compra')"
                  :placeholder="$t('Selecione os dias da semana')"
                  :options="dayOfWeekOptions()"
                  :multiple="true"
                  :instructions="[
                    {
                      text: $t(
                        'Dias da semana em que as requisições de compra devem ser geradas para esta loja.'
                      ),
                    },
                    {
                      text: $t(
                        'Caso nenhum dia seja informado, nenhuma restrição de dia será aplicada.'
                      ),
                    },
                  ]"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <FormulateInput
                  id="installment_enabled"
                  v-model="store.installmentEnabled"
                  name="installmentEnabled"
                  type="switch"
                  :label="$t('Pagamento parcelado habilitado')"
                  :instructions="[
                    {
                      text: $t(
                        'Quando habilitado, o crédito parcelado fica disponível nesta loja conforme a política de parcelamento vigente.'
                      ),
                    },
                    {
                      text: $t(
                        'Desligado, nenhum canal oferece parcelamento — PDV, ATM ou SmartPOS — e um parcelamento que chegue por outro caminho não é registrado.'
                      ),
                    },
                  ]"
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  id="pos_installment_enabled"
                  v-model="store.posInstallmentEnabled"
                  name="posInstallmentEnabled"
                  type="switch"
                  :disabled="!store.installmentEnabled"
                  :label="$t('Parcelamento no POS habilitado')"
                  :instructions="[
                    {
                      text: $t(
                        'Quando habilitado, o PDV oferece as opções de parcelamento também nos pagamentos com POS desta loja.'
                      ),
                    },
                    {
                      text: $t(
                        'No POS a transação já foi feita na maquininha quando o operador informa o NSU, então o sistema não consegue recusar um parcelamento fora da política: apenas registra a divergência. No TEF a validação ocorre antes da autorização e não depende desta opção.'
                      ),
                    },
                  ]"
                />
              </b-col>
            </b-row>
          </b-card-actions>
        </b-tab>
      </b-tabs>

      <FAB
        :main-tooltip="$t('Ações')"
        main-icon="keyboard_command_key"
        :actions="actions"
        :fixed-tooltip="true"
        :busy="busy"
        @save="save"
        @cancel="cancel"
        @active="activateDeactivateStore"
        @inactive="activateDeactivateStore"
        @export="exportStore"
        @import="importStore"
      />
    </FormulateForm>

    <delivery-location-sidebar
      ref="deliveryLocationSidebar"
      @add-item="onAddDeliveryLocation"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import { BRow, BCol, BTable, BCard, BTabs, BTab } from 'bootstrap-vue'
import {
  deliveryDomain,
  formulateHelper,
  storeDomains,
  stringUtils,
  taxRegimes,
  telephoneTypes,
  uploader,
} from '@/mixins'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import { getUserData } from '@/auth/utils'
import {
  EAddress,
  EStoreCombo,
  ECompanyCombo,
  EStatusBadge,
  EButton,
  EGridActions,
  FAB,
} from '@/views/components'
import DeliveryLocationSidebar from './components/DeliveryLocationSidebar.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCardActions,
    BCard,
    BTabs,
    BTab,
    EAddress,
    EStatusBadge,
    FAB,
    EButton,
    DeliveryLocationSidebar,
    EGridActions,
    EStoreCombo,
    ECompanyCombo,
  },
  mixins: [
    formulateHelper,
    stringUtils,
    taxRegimes,
    uploader,
    storeDomains,
    telephoneTypes,
    deliveryDomain,
  ],
  data() {
    return {
      loading: false,
      busy: false,
      userData: getUserData(),
      imageWideLocal: [],
      imageSquareLocal: [],
      digitalCertificateLocal: [],
      digitalCertificateChanged: false,
      isDrawingPolygon: false,
      deliverySupplierToAdd: null,
    }
  },
  computed: {
    ...mapState('pages/store/storeMaintain', ['store', 'heads', 'apiData', 'permitLicenseForm']),
    ...mapState('pages/company/companyMaintain', ['company']),
    ...mapGetters('pages/store/storeMaintain', [
      'getStoreDeliveryLocations',
      'getStoreDeliverySuppliers',
      'availableDeliverySupplierOptions',
      'getStoreWaiterComissions',
      'imageWide',
      'imageSquare',
      'digitalCertificate',
      'digitalCertificateName',
      'headOptions',
      'directorOptions',
      'directorCommercialOptions',
      'investorsOptions',
    ]),
    isEdition() {
      return !!this.$router.currentRoute.params.id
    },

    threeDsRequiredOptions() {
      return [
        { value: 'true', label: this.$t('Sim') },
        { value: 'false', label: this.$t('Não') },
      ]
    },

    // O 3DS tem três estados: vazio (null) segue o parâmetro global; Sim/Não prevalecem sobre ele.
    creditThreeDsRequiredOption: {
      get() {
        const value = this.store.onlinePaymentConfig.creditThreeDsRequired
        return value === null || value === undefined ? null : String(value)
      },
      set(value) {
        this.store.onlinePaymentConfig.creditThreeDsRequired =
          value === null || value === undefined || value === '' ? null : value === 'true'
      },
    },

    deliveryLocationFields() {
      return [
        {
          key: 'actions',
          label: this.$t('Ações'),
          class: 'text-center',
          thStyle: { width: '80px' },
        },
        {
          key: 'city',
          label: this.$t('Cidade'),
          formatter: (val, index, item) => `${val} - ${item.province || ''}`,
        },
      ]
    },

    deliverySupplierFields() {
      return [
        {
          key: 'actions',
          label: this.$t('Ações'),
          class: 'text-center',
          thStyle: { width: '80px' },
        },
        {
          key: 'name',
          label: this.$t('Fornecedor'),
        },
        {
          key: 'supplier',
          label: this.$t('Integração'),
          class: 'text-center',
          thStyle: { width: '200px' },
        },
        {
          key: 'isDefault',
          label: this.$t('Padrão'),
          class: 'text-center',
          thStyle: { width: '120px' },
        },
      ]
    },

    polygonPaths() {
      return (this.store.storeDeliveryPolygons || [])
        .slice()
        .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))
        .map(point => ({ lat: Number(point.lat), lng: Number(point.lng) }))
        .filter(point => !Number.isNaN(point.lat) && !Number.isNaN(point.lng))
    },
    polygonMapCenter() {
      const paths = this.polygonPaths
      if (!paths.length) {
        // Default center: São Paulo
        return { lat: -23.55052, lng: -46.633308 }
      }
      const total = paths.reduce(
        (acc, point) => ({ lat: acc.lat + point.lat, lng: acc.lng + point.lng }),
        { lat: 0, lng: 0 }
      )
      return { lat: total.lat / paths.length, lng: total.lng / paths.length }
    },
    polygonOptions() {
      return {
        strokeColor: '#FF5733',
        strokeOpacity: 0.9,
        strokeWeight: 2,
        fillColor: '#FF5733',
        fillOpacity: 0.25,
      }
    },
    storeAddressPosition() {
      const lat = Number(this.store?.address?.lat)
      const lng = Number(this.store?.address?.lng)
      if (Number.isNaN(lat) || Number.isNaN(lng) || (!lat && !lng)) return null
      return { lat, lng }
    },
    waiterComissionFields() {
      return [
        {
          key: 'actions',
          label: this.$t('Ações'),
          class: 'text-center',
          thStyle: { width: '80px' },
        },
        {
          key: 'comissionFee',
          label: this.$t('Comissão (%)'),
          formatter: val => this.$options.filters.percentage(val),
        },
      ]
    },

    enableDigitalCertificatePassword() {
      return this.digitalCertificateChanged && this.digitalCertificateLocal?.length
    },
    actions() {
      const actions = [
        {
          name: 'cancel',
          icon: 'arrow_back',
          color: 'red',
          tooltip: this.$t('Voltar'),
        },
      ]

      if (this.isEdition) {
        actions.push({
          name: 'export',
          icon: 'download',
          color: 'green',
          tooltip: this.$t('Exportar'),
        })
      } else {
        actions.push({
          name: 'import',
          icon: 'upload',
          color: 'green',
          tooltip: this.$t('Importar'),
        })
      }

      if (this.isEdition && this.$can('Activate', 'Store') && !this.store.active) {
        actions.push({
          name: 'active',
          icon: 'toggle_on',
          color: 'green',
          tooltip: this.$t('Ativar'),
        })
      }
      if (this.isEdition && this.$can('Deactivate', 'Store') && this.store.active) {
        actions.push({
          name: 'inactive',
          icon: 'toggle_off',
          color: 'red',
          tooltip: this.$t('Inativar'),
        })
      }
      actions.push({
        name: 'save',
        icon: 'save',
        tooltip: this.$t('Salvar'),
      })
      return actions
    },
  },
  watch: {
    // 3DS obrigatório só existe na Getnet: o cadastro com Stripe é recusado pela API.
    'store.onlinePaymentConfig.creditAcquirer': function onCreditAcquirerChange(acquirer) {
      if (acquirer === 'STRIPE') {
        this.store.onlinePaymentConfig.creditThreeDsRequired = null
      }
    },
    imageWide(val) {
      this.imageWideLocal = val ? [val] : []
    },
    imageSquare(val) {
      this.imageSquareLocal = val ? [val] : []
    },
    digitalCertificate(val) {
      this.digitalCertificateLocal = val ? [val] : []
    },
    digitalCertificateLocal(val) {
      if (!this.loading) {
        this.digitalCertificateChanged = !!val
      }
      if (!val?.length) {
        this.store.digitalCertificateDueDate = null
      }
    },
    'store.deliveryType': function watchDeliveryType(val) {
      if (val === this.storeDeliveryTypesEnum.POLYGON) {
        this.$nextTick(() => this.renderPolygonOnMap())
      } else {
        this.stopDrawingPolygon()
        this.removeMapPolygon()
      }
    },
  },
  created() {
    // Native Google Maps objects kept off the reactive data() on purpose (Vue should not observe them).
    this.mapPolygon = null
    this.mapClickListener = null
    this.polygonListeners = []
  },
  async mounted() {
    this.$store.dispatch('pages/store/storeMaintain/clearStore')
    this.loading = true
    Promise.all([
      this.getData(),
      this.fetchHeads(),
      this.fetchInvestors(),
      this.fetchDirectors(),
      this.fetchDirectorsCommercial(),
      this.fetchDeliverySuppliers(),
    ]).finally(() => {
      this.loading = false
    })
  },
  beforeDestroy() {
    this.removeMapPolygon()
  },

  methods: {
    ...mapActions('app', { appFetchStores: 'fetchStores' }),
    ...mapActions('pages/company/companyMaintain', ['fetchCompany']),
    ...mapActions('pages/store/storeMaintain', [
      'removeDeliveryLocation',
      'addDeliveryLocation',
      'fetchDeliverySuppliers',
      'addDeliverySupplier',
      'removeDeliverySupplier',
      'setDefaultDeliverySupplier',
      'removeWaiterComission',
      'addWaiterComission',
      'fetchHeads',
      'fetchDirectors',
      'fetchDirectorsCommercial',
      'fetchInvestors',
      'setCompanyData',
    ]),
    ...mapMutations('pages/store/storeMaintain', ['SET_STORE']),

    // O tempo de instalação do comodato anda de 5 em 5 minutos (mesma regra do backend).
    multipleOf5({ value }) {
      if (value === '' || value === null || value === undefined) return true
      return Number(value) % 5 === 0
    },

    async loadCompanyData(companyId) {
      const company = await this.fetchCompany(companyId)
      this.setCompanyData(company)
    },
    async getData() {
      if (this.$router.currentRoute.params.companyId) {
        this.loadCompanyData(this.$router.currentRoute.params.companyId)
      }

      if (this.$router.currentRoute.params.id) {
        try {
          this.loading = true
          await this.$store.dispatch(
            'pages/store/storeMaintain/fetchStore',
            this.$router.currentRoute.params.id
          )
        } catch (error) {
          this.showGenericError({ error })
          this.$router.push({ name: 'store-list' })
        } finally {
          this.loading = false
        }
      }
    },

    onShowDeliveryLocationSidebar() {
      this.$refs.deliveryLocationSidebar.showCreate()
    },
    onAddDeliveryLocation(formData) {
      const indexFound = this.getStoreDeliveryLocations.findIndex(
        loc => loc.city === formData?.city && loc.province === formData?.province
      )
      if (indexFound > -1) {
        this.showError({ message: this.$t('A cidade já foi adicionada') })
        return
      }

      this.addDeliveryLocation(formData)
      this.$refs.deliveryLocationSidebar.hideSidebar()
    },
    async onRemoveDeliveryLocation(item) {
      const confirm = await this.confirm({
        title: this.$t('Deseja remover esta cidade?'),
      })
      if (!confirm) return
      this.removeDeliveryLocation(item.id || item.localId)
    },

    onAddDeliverySupplier() {
      if (!this.deliverySupplierToAdd) {
        this.showInvalidDataMessage({ message: this.$t('Selecione um fornecedor de delivery') })
        return
      }

      const supplier = this.availableDeliverySupplierOptions.find(
        option => String(option.value) === String(this.deliverySupplierToAdd)
      )
      if (!supplier) return

      this.addDeliverySupplier({
        id: null,
        deliverySupplierId: supplier.id,
        name: supplier.name,
        supplier: supplier.supplier,
        // O primeiro fornecedor associado já entra como padrão.
        isDefault: this.getStoreDeliverySuppliers.length === 0,
      })
      this.deliverySupplierToAdd = null
    },
    async onRemoveDeliverySupplier(item) {
      const confirm = await this.confirm({
        title: this.$t('Deseja remover este fornecedor de delivery?'),
      })
      if (!confirm) return

      this.removeDeliverySupplier(item.id || item.localId)
    },
    onSetDefaultDeliverySupplier(item, isDefault) {
      if (!isDefault) return
      this.setDefaultDeliverySupplier(item.id || item.localId)
    },

    onAddWaiterComission() {
      this.addWaiterComission({
        id: null,
        comissionFee: 0,
      })
    },
    async onRemoveWaiterComission(item) {
      const confirm = await this.confirm({
        title: this.$t('Deseja remover esta comissão?'),
      })
      if (!confirm) return

      this.removeWaiterComission(item.id || item.localId)
    },

    cancel() {
      this.$router.go(-1)
      this.$store.dispatch('pages/store/storeMaintain/clearStore')
    },

    async save() {
      this.$refs.form.showErrors()
      const addressValid = this.$refs.address.validate()
      if (this.$refs.form.isValid && addressValid) {
        // input de grupo do formulate ocorre bug com "validation required" nos inputs dentro qnd adiciona e depois remove um item.
        // Para evitar, foi feito verificação manual.
        if (!this.validateTelephones()) {
          this.showInvalidDataMessage({ message: this.$t('Em telefones') })
          return
        }

        const { telephones: apiTelephones } = this.apiData
        const { telephones } = this.store
        const notInTelephonesForm = tApi => telephones.findIndex(t => t.id === tApi.id) < 0
        const telephonesDeleted = apiTelephones
          .filter(tApi => notInTelephonesForm(tApi))
          .map(tDeleted => ({ ...tDeleted, isDeleted: true }))

        try {
          this.busy = true
          const uploadResult = await this.uploadImages()
          const [imageWide, imageSquare] = uploadResult
          this.store.imageWide = imageWide.url
          this.store.imageSquare = imageSquare.url

          const data = {
            ...this.store,
            telephones: [...telephones, ...telephonesDeleted],
            taxCode: this.store.taxCode || null,
            maxProductItemsSell: this.store.maxProductItemsSell || null,
          }

          await this.$http({
            url: '/api/stores',
            method: this.isEdition ? 'PUT' : 'POST',
            data,
          })

          this.showSuccess({ message: this.$t('Loja salva com sucesso') })
          await this.appFetchStores()
          if (this.$router.currentRoute.params.companyId) {
            this.$router.push({
              name: 'company-maintain',
              params: { id: this.$router.currentRoute.params.companyId },
            })
          } else {
            this.$router.push({ name: 'store-list' })
            this.$store.dispatch('pages/store/storeMaintain/clearStore')
            this.$store.dispatch('pages/store/storeMaintain/fetchStores')
          }
        } catch (error) {
          this.showError({ error, message: this.$t('Não foi possível concluir a operação') })
        } finally {
          this.busy = false
        }
      } else {
        this.showInvalidDataMessage()
      }
    },

    async uploadImages() {
      let resultWide = null
      let resultSquare = null
      const result = await this.upload({
        files: [...this.imageWideLocal, ...this.imageSquareLocal],
        destinationPath: 'images/stores',
      })
      if (this.imageWideLocal.length) {
        ;[resultWide] = result
      }
      if (this.imageSquareLocal.length) {
        ;[resultSquare] = result.slice(result.length > 1 ? 1 : 0)
      }
      const nullResult = { url: null }
      return [resultWide || nullResult, resultSquare || nullResult]
    },

    validateTelephones() {
      const { telephones } = this.store
      let isValid = true

      if (telephones.length > 0) {
        isValid = !telephones.some(t => !(t.number && t.type))
      }

      return isValid
    },

    async activateDeactivateStore() {
      try {
        const confirm = await this.confirm()
        if (confirm) {
          const { id, active } = this.store

          const path = active ? 'deactivate' : 'activate'
          await this.$http({
            url: `/api/stores/${path}/${id}`,
            method: 'PUT',
          })
          this.getData()
          this.showSuccess({
            message: this.$t(`${active === true ? 'Inativado' : 'Ativado'} com sucesso`),
          })
          await this.appFetchStores()
        }
      } catch (error) {
        this.showError({ error })
      }
    },

    exportStore() {
      // Convert JSON object to string
      const jsonString = JSON.stringify(this.store)

      // Create a blob with the JSON string
      const blob = new Blob([jsonString], { type: 'application/json' })

      // Create a link for downloading the file
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `Store_${this.$options.filters.storeName(
        this.store
      )}_${moment().format()}.json`

      // Click the link to start downloading the file
      link.click()

      // Clean up the link and blob objects
      URL.revokeObjectURL(link.href)
      link.remove()
    },

    importStore() {
      // Create an input element for selecting files
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'application/json'

      // Add an event listener for when a file is selected
      input.addEventListener('change', () => {
        const file = input.files[0]

        // Use a FileReader to read the contents of the file
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const jsonObj = JSON.parse(reader.result)

            // Do something with the loaded JSON object

            this.SET_STORE(jsonObj)
          } catch (e) {
            this.showError({ message: this.$t('Não foi possível ler o arquivo') })
            console.error('Failed to parse JSON from file', e)
          }
        }
        reader.readAsText(file)
      })

      // Click the input element to trigger the file selection dialog
      input.click()
    },

    importPolygonSpreadsheet() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.csv,text/csv,text/plain'

      input.addEventListener('change', () => {
        const file = input.files[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = () => {
          try {
            this.parsePolygonFromText(reader.result)
          } catch (e) {
            this.showError({ message: this.$t('Não foi possível ler o arquivo') })
            console.error('Failed to parse polygon spreadsheet', e)
          }
        }
        reader.readAsText(file)
      })

      input.click()
    },

    parsePolygonFromText(text) {
      // Extract the coordinates from the WKT POLYGON item, e.g.:
      // POLYGON ((-46.588 -23.450, -46.665 -23.454, ...))
      const match = /POLYGON\s*\(\(([^)]*)\)\)/i.exec(text)
      if (!match) {
        this.showError({
          message: this.$t('Não foi encontrado um item POLYGON válido na planilha'),
        })
        return
      }

      const polygons = []
      match[1].split(',').forEach((pair, index) => {
        const parts = pair.trim().split(/\s+/)
        if (parts.length >= 2) {
          // WKT uses the order "longitude latitude"
          const lng = parseFloat(parts[0])
          const lat = parseFloat(parts[1])
          if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
            polygons.push({ sequence: index, lat, lng })
          }
        }
      })

      if (polygons.length < 3) {
        this.showError({ message: this.$t('O polígono precisa ter ao menos 3 pontos') })
        return
      }

      this.stopDrawingPolygon()
      this.store.storeDeliveryPolygons = polygons
      this.$nextTick(() => this.renderPolygonOnMap())
      this.showSuccess({ message: this.$t('Polígono importado com sucesso') })
    },

    clearPolygon() {
      this.stopDrawingPolygon()
      this.removeMapPolygon()
      this.store.storeDeliveryPolygons = []
    },

    toggleDrawPolygon() {
      if (this.isDrawingPolygon) {
        this.finishDrawingPolygon()
      } else {
        this.startDrawingPolygon()
      }
    },

    // The DrawingManager was removed from the Maps JS API (v3.65+), so drawing is done by
    // capturing map clicks and appending each one as a vertex of an editable polygon.
    async startDrawingPolygon() {
      const mapRef = this.$refs.polygonMapRef
      if (!mapRef) return

      const map = await mapRef.$mapPromise
      const google = gmapApi()
      if (!google) {
        this.showError({ message: this.$t('Não foi possível iniciar o modo de desenho') })
        return
      }

      // A store has a single delivery polygon, so discard the current one before drawing a new one.
      this.removeMapPolygon()
      this.store.storeDeliveryPolygons = []

      this.mapPolygon = new google.maps.Polygon({
        ...this.polygonOptions,
        editable: true,
        draggable: false,
      })
      // Ensure the polygon has one (empty) path ring so getPath() is valid before any vertex exists.
      this.mapPolygon.setPath([])
      this.mapPolygon.setMap(map)
      this.bindPolygonListeners()

      this.mapClickListener = map.addListener('click', event => {
        if (this.mapPolygon) {
          this.mapPolygon.getPath().push(event.latLng)
        }
      })

      map.setOptions({ draggableCursor: 'crosshair' })
      this.isDrawingPolygon = true
    },

    finishDrawingPolygon() {
      this.stopDrawingPolygon()
      if (this.polygonPaths.length < 3) {
        this.showError({ message: this.$t('O polígono precisa ter ao menos 3 pontos') })
      }
    },

    stopDrawingPolygon() {
      const google = gmapApi()
      if (this.mapClickListener && google) {
        google.maps.event.removeListener(this.mapClickListener)
        this.mapClickListener = null
      }

      // Once finished, allow moving the whole polygon to fine-tune its position.
      if (this.mapPolygon) {
        this.mapPolygon.setDraggable(true)
      }

      const mapRef = this.$refs.polygonMapRef
      if (mapRef) {
        mapRef.$mapPromise.then(map => map.setOptions({ draggableCursor: null }))
      }

      this.isDrawingPolygon = false
    },

    async renderPolygonOnMap() {
      const mapRef = this.$refs.polygonMapRef
      if (!mapRef) return

      const map = await mapRef.$mapPromise
      const google = gmapApi()
      if (!google) return

      this.renderStoreMarker(map, google)

      // The rendered polygon is editable/draggable, so it can be adjusted without redrawing.
      this.removeMapPolygon()
      const paths = this.polygonPaths
      if (paths.length) {
        this.mapPolygon = new google.maps.Polygon({
          paths,
          ...this.polygonOptions,
          editable: true,
          draggable: true,
        })
        this.mapPolygon.setMap(map)
        this.bindPolygonListeners()
      }

      this.centerPolygonMap(map, google)
    },

    renderStoreMarker(map, google) {
      const position = this.storeAddressPosition
      if (!position) {
        this.removeStoreMarker()
        return
      }
      if (!this.storeMarker) {
        this.storeMarker = new google.maps.Marker({
          map,
          title: this.$t('Endereço da loja'),
        })
      }
      this.storeMarker.setPosition(position)
    },

    removeStoreMarker() {
      if (this.storeMarker) {
        this.storeMarker.setMap(null)
        this.storeMarker = null
      }
    },

    centerPolygonMap(map, google) {
      const position = this.storeAddressPosition
      // Center on the store pin. When a polygon exists, frame both so nothing is cut off.
      if (this.polygonPaths.length) {
        const bounds = new google.maps.LatLngBounds()
        this.polygonPaths.forEach(point => bounds.extend(point))
        if (position) bounds.extend(position)
        map.fitBounds(bounds)
      } else if (position) {
        map.setCenter(position)
        map.setZoom(14)
      }
    },

    /**
     * Reads the current vertices from the polygon drawn/edited on the map and stores them,
     * keeping their order through the "sequence" property.
     */
    syncPolygonFromMap() {
      if (!this.mapPolygon) return

      const path = this.mapPolygon.getPath()
      const points = []
      for (let i = 0; i < path.getLength(); i += 1) {
        const point = path.getAt(i)
        points.push({ sequence: i, lat: point.lat(), lng: point.lng() })
      }
      this.store.storeDeliveryPolygons = points
    },

    bindPolygonListeners() {
      const google = gmapApi()
      if (!google || !this.mapPolygon) return

      this.unbindPolygonListeners()
      const path = this.mapPolygon.getPath()
      if (!path) return
      const sync = () => this.syncPolygonFromMap()
      this.polygonListeners = [
        path.addListener('set_at', sync),
        path.addListener('insert_at', sync),
        path.addListener('remove_at', sync),
        this.mapPolygon.addListener('dragend', sync),
      ]
    },

    unbindPolygonListeners() {
      const google = gmapApi()
      if (google && this.polygonListeners) {
        this.polygonListeners.forEach(listener => google.maps.event.removeListener(listener))
      }
      this.polygonListeners = []
    },

    removeMapPolygon() {
      const google = gmapApi()
      if (this.mapClickListener && google) {
        google.maps.event.removeListener(this.mapClickListener)
        this.mapClickListener = null
      }
      this.unbindPolygonListeners()
      if (this.mapPolygon) {
        this.mapPolygon.setMap(null)
        this.mapPolygon = null
      }
    },

    fitPolygonBounds() {
      const mapRef = this.$refs.polygonMapRef
      if (!mapRef || !this.polygonPaths.length) return

      mapRef.$mapPromise.then(map => {
        const google = gmapApi()
        if (!google) return
        const bounds = new google.maps.LatLngBounds()
        this.polygonPaths.forEach(point => bounds.extend(point))
        map.fitBounds(bounds)
      })
    },
  },
}
</script>
<style>
.bg-light-gray {
  background-color: #f2f2f2;
}
</style>
